var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserOutlined = function SvgUserOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596379",
    d: "M12 10.8a3.93 3.93 0 1 0-.002-7.862A3.93 3.93 0 0 0 12 10.8m0-6.25c1.28 0 2.33 1.04 2.33 2.33S13.29 9.21 12 9.21 9.67 8.17 9.67 6.88 10.71 4.55 12 4.55M20.98 18.12c-.31-3.66-2.54-6.08-5.69-6.15-2.18-.04-4.4-.04-6.59 0-3.14.08-5.37 2.49-5.68 6.14-.09.88.16 1.7.69 2.3.49.56 1.19.89 1.98.92 2.09.07 4.2.1 6.31.1s4.22-.03 6.31-.1c.78-.03 1.48-.35 1.97-.92.53-.61.78-1.43.69-2.29zm-1.9 1.24c-.2.23-.49.36-.83.37-4.15.13-8.36.13-12.51 0-.34-.01-.63-.14-.83-.37-.23-.27-.34-.67-.3-1.1.19-2.22 1.37-4.62 4.12-4.69 1.08-.02 2.17-.03 3.26-.03s2.18 0 3.25.03c2.76.07 3.94 2.47 4.13 4.7.04.43-.07.83-.3 1.09z"
  })));
};
export default SvgUserOutlined;